import { Skeleton } from "@envestnet/envreact-component-library";
import React from "react";
export const PasswordPoliciesLoader = (): JSX.Element => (
  <>
    <div style={{ display: "flex", marginTop: 16 }}>
      <Skeleton variant="circle" height={15} width={15} />
      <Skeleton height={15} width={230} style={{ marginLeft: 10 }} />
    </div>
    <div style={{ display: "flex", marginTop: 5 }}>
      <Skeleton variant="circle" height={15} width={15} />
      <Skeleton height={15} width={180} style={{ marginLeft: 10 }} />
    </div>
    <div style={{ display: "flex", marginTop: 5 }}>
      <Skeleton variant="circle" height={15} width={15} />
      <Skeleton height={15} width={190} style={{ marginLeft: 10 }} />
    </div>
    <div style={{ display: "flex", marginTop: 5 }}>
      <Skeleton variant="circle" height={15} width={15} />
      <Skeleton height={15} width={100} style={{ marginLeft: 10 }} />
    </div>
    <div style={{ display: "flex", marginTop: 5 }}>
      <Skeleton variant="circle" height={15} width={15} />
      <Skeleton height={15} width={200} style={{ marginLeft: 10 }} />
    </div>
    <div style={{ display: "flex", marginTop: 5 }}>
      <Skeleton variant="circle" height={15} width={15} />
      <Skeleton height={15} width={230} style={{ marginLeft: 10 }} />
    </div>
    <div style={{ display: "flex", marginTop: 5 }}>
      <Skeleton variant="circle" height={15} width={15} />
      <Skeleton height={15} width={250} style={{ marginLeft: 10 }} />
    </div>
    <div style={{ display: "flex", marginTop: 5 }}>
      <Skeleton variant="circle" height={15} width={15} />
      <Skeleton height={15} width={230} style={{ marginLeft: 10 }} />
    </div>
    <div style={{ display: "flex", marginTop: 5 }}>
      <Skeleton variant="circle" height={15} width={15} />
      <Skeleton height={15} width={230} style={{ marginLeft: 10 }} />
    </div>
  </>
);
